import { useQuery } from '@apollo/react-hooks';

import { UsersInfoQuery } from './UsersInfoQuery.graphql';
import type {
	UsersInfoQuery as UsersInfoQueryType,
	UsersInfoQueryVariables,
} from './__types__/UsersInfoQuery';
import type { UserInfo } from './TopPremiumUsers';

type HookProps = {
	accountIds?: string[];
	skip?: boolean;
};

export const useUsersInfoQuery = ({ accountIds = [], skip = false }: HookProps) => {
	const { data, loading, error } = useQuery<UsersInfoQueryType, UsersInfoQueryVariables>(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		UsersInfoQuery,
		{
			variables: {
				accountIds,
			},
			skip: accountIds.length === 0 || skip,
		},
	);
	const usersData = data?.confluenceUsers?.nodes ?? [];
	const usersInfo =
		usersData.reduce<{ [key: string]: UserInfo }>((userInfoObj, userInfo) => {
			if (userInfo?.displayName && userInfo?.profilePicture?.path) {
				// @ts-ignore The generated types are unions that are difficult to narrow.
				userInfoObj[userInfo.accountId] = {
					displayName: userInfo.displayName,
					avatarUrl: userInfo.profilePicture.path,
				};
			}

			return userInfoObj;
		}, {}) || {};

	const isUsersInfoValid = Object.keys(usersInfo).length > 0;

	return {
		isUsersInfoValid,
		usersInfo,
		error,
		loading,
	};
};
